[{
    "max_width_mobile_portrait": 450,
    "max_width_mobile_landscape": 1000,
    "min_width_desktop": 1280
}]